import React, { useState } from "react";

import { ICommandTemplate } from "@formant/core/model/ICommandTemplate";

import { Scrollable } from "../../common/Scrollable";
import { CommandTemplateHeader } from "./sections/CommandTemplateHeader";
import { CommandTemplatesCreate } from "./sections/CommandTemplatesCreate";
import { CommandTemplateSearch } from "./sections/CommandTemplateSearch";
import { CommandTemplatesList } from "./sections/CommandTemplatesList";

export const CommandTemplates: React.FC = () => {
    const [view, setView] = useState<"list" | "create">("list");
    const [commandTemplate, setCommandTemplate] =
        useState<ICommandTemplate | null>(null);
    const [filteredCommands, setFilteredCommands] = useState<
        ICommandTemplate[]
    >([]);
    const [canReorder, setCanReorder] = useState(true);
    const [listRevision, setListRevision] = useState(0);

    const toggleView = () => {
        setCommandTemplate(null);
        setView(view === "list" ? "create" : "list");
        if (view === "create") {
            setListRevision(value => value + 1);
        }
    };

    const handleCommandTemplateEdit = (item: ICommandTemplate) => {
        setView("create");
        setCommandTemplate(item);
    };

    const handleOnCancel = () => {
        setCommandTemplate(null);
        setView("list");
        setListRevision(value => value + 1);
    };

    return (
        <div className="h-full flex flex-col">
            <CommandTemplateHeader toggleView={toggleView} view={view} />
            {view === "list" && (
                <CommandTemplateSearch
                    onFilteredCommandsChange={setFilteredCommands}
                    onCanReorderChange={setCanReorder}
                    listRevision={listRevision}
                />
            )}
            <Scrollable className="flex-1">
                {view === "list" ? (
                    <CommandTemplatesList
                        onCommandTemplateEdit={handleCommandTemplateEdit}
                        commands={filteredCommands}
                        canReorder={canReorder}
                        onReordered={() => setListRevision(value => value + 1)}
                    />
                ) : (
                    <CommandTemplatesCreate
                        onCancel={handleOnCancel}
                        commandTemplate={commandTemplate || undefined}
                    />
                )}
            </Scrollable>
        </div>
    );
};
